import { render, staticRenderFns } from "./cxModal.vue?vue&type=template&id=65f27251"
import script from "./cxModal.vue?vue&type=script&lang=js"
export * from "./cxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports